<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shortPage.shortCodeList')}}
                    </label>
                </div>
                <div class="col-auto" v-if="userRole === 5">
                    <router-link to="/Shorts/AddShortCode" tag="button" class="btn btn-primary"><span class="text_sm_hidden">{{$t('shortPage.addNewShortCode')}}</span><i class="fas fa-plus px-2"></i></router-link>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 pr-0">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.operator"
                                       :placeholder="$t('shortPage.operatorSearch')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.name"
                                       :placeholder="$t('shortPage.shortcodeSearch')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template>
                        <v-data-table :headers="headers"
                                      :items="shorts"
                                      :total-items="shortsCount"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      @update:pagination="updatePaginate"
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ getOperatorText(props.item.operatorId) }}</td>
                                    <td v-if="userRole === 9 || userRole === 5 || userRole === 2" class="text-center">{{ getProviderNameForRow(props.item) }}</td>
                                    <td class="text-center">{{ props.item.name }}</td>
                                    <td class="text-center">{{getShortCodeType(props.item.shortCodeType)}}</td>
                                    <td class="text-center">
                                        <i v-if="userRole === 5 || userRole === 9" class="far fa-trash-alt Icon_delete" @click="onDeleteClick(props.item.id,props.item.name)"></i>
                                        <i v-if="userRole === 5 || userRole === 9" class="fas fa-unlink Icon_delete" @click="onDisconnectClick(props.item.id)"></i>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="otpDialog" persistent width="554">

            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{ $t('shortPage.confirmDeleteShortCode') }}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideOtpDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{ $t('shortPage.deleteOtpMessage') }}
                    </p>

                    <p>{{$t('shortPage.otpRemainingTimeLabel')}}: {{ formattedTime }}</p>

                    <div class="row row_input pb-4">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control text-center" maxlength="6"
                                           v-model="otpCode"
                                           @keyup.enter="verifyOtp"
                                           @keypress="isNumberField($event)"
                                           @paste="isNumberFieldPaste($event)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto">
                            <button class="btn btn-primary mb-2"
                                    :disabled="countDown > 0"
                                    @click="resendOtp">
                                {{$t('shortPage.resendOtpButton')}}
                            </button>
                            <button class="btn btn-success mb-2"
                                    :disabled="otpCode.length !== 6"
                                    @click="verifyOtp">
                                {{$t('shortPage.verifyOtpButton')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="disconnectDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{ $t('shortPage.confirmDisconnectTitle') }}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDisconnectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{ $t('shortPage.confirmDisconnectMessage') }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDisconnectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="confirmDisconnect">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>

